export default "__VITE_ASSET__CVZEil$t__"